var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutDialog = function SvgLogoutDialog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.089 5.648v5.034a.5.5 0 1 0 1 0V5.648c0-1.544-1.31-2.8-2.918-2.8H5.042c-1.608 0-2.917 1.256-2.917 2.8v15.004a.5.5 0 0 0 1 0V5.648c0-.993.86-1.8 1.917-1.8h8.129c1.058 0 1.918.807 1.918 1.8m6.755 8.092.008-.026a.5.5 0 0 0 .023-.142q-.002-.075-.023-.142l-.008-.026a.5.5 0 0 0-.067-.126l-.004-.008-2.076-2.746a.5.5 0 1 0-.798.603l1.471 1.945h-8.595a.5.5 0 0 0 0 1h8.595l-1.471 1.945a.5.5 0 1 0 .797.603l2.077-2.747.005-.007a.5.5 0 0 0 .066-.126m-5.756 2.72v4.192a.5.5 0 0 1-1 0V16.46a.5.5 0 1 1 1 0",
    clipRule: "evenodd"
  })));
};
export default SvgLogoutDialog;